import DateService from '@/services/DateService'
import PlanningService from '@/services/PlanningService'
import Task from '@/components/Task'
export const tasks = {
	components: {
		Task
	},
	methods: {
		getWeekTasks (week, tasks, options) {
			return PlanningService.getWeekTasks(week, tasks, options)
		},
		getDayOfWeek (weekDate, day) {
			return DateService.getDayOfWeek(weekDate, day)
		},
		getDaysOfWeek (weekDate, days) {
			var daysOfWeek = []
			days.forEach(function (day) {
				daysOfWeek.push(DateService.getDayOfWeek(weekDate, day))
			})
			return daysOfWeek
		}
	}
}
